import Cookies from 'js-cookie'
import { getLanguage } from '@/lang/index'

const state = {
  device: getDeviceType(),
  language: getLanguage(),//存储语言
  domain:Cookies.get('domain'),//存储域名用于判断
  showSearch:true,//显示搜索框
}

const mutations = {
  SET_DOMAIN: (state, domain) => {//设置域名
    state.domain = domain
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_LANGUAGE: (state, language) => {
    Cookies.set('language',language)
    state.language = language
  },
  SET_SHOWSEARCH: (state, showSearch) => {//设置是否显示搜索框
    state.showSearch = showSearch
  },
}

const actions = {
  set_domain({ commit }, domain){//设置域名
    if(Cookies.get('domain') && Cookies.get('domain') == domain){
      return
    }else{
      Cookies.set('domain', domain)
      // commit('SET_DOMAIN', domain)
    }
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setLanguage({ commit }, language) {
    commit('SET_LANGUAGE', language)
  },
  set_showSearch({ commit }, showSearch) { //设置是否显示搜索框
    commit('SET_SHOWSEARCH', showSearch)
  },
}
function getDeviceType() {
  const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag ? 'mobile' : 'pc'
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
